module.exports = __webpack_public_path__ + "static/media/hight.564d1517.svg";